import actionTypes from '../constants/action-types';

const clearDomainPurchaseData = () => ({
  type: actionTypes.CLEAR_DOMAIN_PURCHASE_DATA,
});

export default clearDomainPurchaseData;
